import { render, staticRenderFns } from "./room.vue?vue&type=template&id=49c7ea60&scoped=true&"
import script from "./room.vue?vue&type=script&lang=js&"
export * from "./room.vue?vue&type=script&lang=js&"
import style0 from "./room.vue?vue&type=style&index=0&id=49c7ea60&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c7ea60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49c7ea60')) {
      api.createRecord('49c7ea60', component.options)
    } else {
      api.reload('49c7ea60', component.options)
    }
    module.hot.accept("./room.vue?vue&type=template&id=49c7ea60&scoped=true&", function () {
      api.rerender('49c7ea60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/battleRoyale/room.vue"
export default component.exports